export default __webpack_public_path__ + "static/media/stats.3e4cebae.svg";